import PASSIVE_SUPPORT from 'constants/passive-events';
import {
  POINTER_DOWN as POINTER_DOWN_EVENTS,
  POINTER_UP as POINTER_UP_EVENTS,
} from 'constants/events';
import * as doubleTap from 'gestures/double-tap';
import * as longpress from 'gestures/longpress';

class GesturesManager {
  constructor() {
    this.onDown = this.onDown.bind(this);
    this.onUp = this.onUp.bind(this);
  }

  public init() {
    POINTER_DOWN_EVENTS.forEach((event) => {
      document.addEventListener(event, this.onDown, PASSIVE_SUPPORT);
    });

    POINTER_UP_EVENTS.forEach((event) => {
      document.addEventListener(event, this.onUp, PASSIVE_SUPPORT);
    });
  }

  public onDown(e: any) {
    doubleTap.down(e);
    longpress.down(e);
  }

  public onUp(e: any) {
    doubleTap.up(e);
    longpress.up(e);
  }
}

export default new GesturesManager();
